export default __webpack_public_path__ + "static/media/brauliov2.8d29d74f.png";